<template>
    <!-- 导入IP弹窗 -->
    <el-dialog
        :visible.sync="dialogVisible"
        top="20vh"
        @close="closeDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="import_dialog"
        :class="{app_import_dialog: type === 'app'}">
        <div class="form-container" v-if="$slots.default">
            <slot></slot>
        </div>
        <el-input
            maxlength="100000"
            class="text_style"
            type="textarea"
            v-model="ipContent"
            :placeholder="placeholder"
            ></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button
                type="primary"
                :size="type === 'app' ? 'mini' : 'small'"
                @click="confirm">
                {{ $t("cpts.import_ips.actions.confirm") }}
            </el-button>
            <el-button @click="closeDialog"  :size="type === 'app' ? 'mini' : 'small'">{{ $t("cpts.import_ips.actions.cancel") }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: 'format：\n IP:PORT:USER:PASS',
        },
        type: {
            type: String,
            default: 'pc'
        },
        // 新增props支持外部设置IP内容
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            // 使用本地data属性避免直接修改prop
            localContent: this.content
        };
    },
    computed: {
        // 使用计算属性作为v-model的绑定值
        ipContent: {
            get() {
                return this.localContent;
            },
            set(value) {
                this.localContent = value;
            }
        }
    },
    watch: {
        // 监听content变化更新localContent
        content(newVal) {
            this.localContent = newVal;
        }
    },
    methods: {
        showDialog() {
            this.dialogVisible = true;
        },
        closeDialog() {
            this.dialogVisible = false;
            this.localContent = this.content; // 关闭时重置为props传入的值
        },
        confirm() {
            // 去掉每行前后空格并过滤空行
            const cleanedContent = this.localContent
              .split('\n')
              .map(line => line.trim())
              .filter(line => line.length > 0)
              .join('\n');
            if (this.localContent.length == 0) {
                return  this.$message.warning(this.$t("cpts.import_ips.messages.ips_missing"));
            }
            this.$emit('confirm', cleanedContent);
            this.$emit('input', cleanedContent); // 新增input事件支持v-model
        },
        // 新增方法用于外部设置内容
        setContent(content) {
            this.localContent = content;
        }
    }
};
</script>
<style lang="scss" scoped>
.import_dialog {
    .text_style {
        height: 300px;
        overflow: hidden;
        white-space: pre-wrap;
       ::v-deep textarea {
            height: 100%;
        }
    }
    .w0100 {
        width: 100%;
    }
}
.app_import_dialog{
   ::v-deep .el-dialog {
        width: 90%;
        .el-dialog__body {
            padding: 16px 24px;
        }
    }
}
</style>
